import { GlobalService } from './global.service'

let _g: GlobalService = null
export const defineGlobal = g => _g = g

